import { Lightbulb } from "lucide-react";
import { analystConclusion } from "../lib/calc";

export const AnalystConclusion = ({ stats }) => (
  <div data-testid="analyst-conclusion-card" className="panel relative overflow-hidden border-l-4 border-l-amber-500 p-6">
    <div className="label flex items-center gap-2 text-amber-400"><Lightbulb className="h-4 w-4" /> Analyst Conclusion</div>
    <p data-testid="analyst-conclusion-text" className="mt-3 max-w-4xl leading-relaxed">{analystConclusion(stats)}</p>
  </div>
);
